import { Stack } from '@mui/material'

import Item from '~/features/chatbot/components/simple/header/links/item'
import { TLink } from '~/features/settings/models'

type TProps = {
  links: TLink[]
}

function Links({ links }: TProps) {
  return (
    <Stack gap={0}>
      {links.map((link) => (
        <Item key={link.id} {...link} />
      ))}
    </Stack>
  )
}

export default Links
